export default {
  'pages.layouts.userLayout.title':
    'Ant Design é a especificação de web design mais influente no distrito de Xihu',
  'pages.login.accountLogin.tab': 'Login da conta',
  'pages.login.accountLogin.errorMessage':
    'usuário/senha incorreto(admin/ant.design)',
  'pages.login.failure': 'Login falhou, por favor tente novamente!',
  'pages.login.success': 'Login efetuado com sucesso!',
  'pages.login.username.placeholder': 'Usuário: admin or user',
  'pages.login.username.required': 'Por favor insira seu usuário!',
  'pages.login.password.placeholder': 'Senha: ant.design',
  'pages.login.password.required': 'Por favor insira sua senha!',
  'pages.login.phoneLogin.tab': 'Login com Telefone',
  'pages.login.phoneLogin.errorMessage': 'Erro de Código de Verificação',
  'pages.login.phoneNumber.placeholder': 'Telefone',
  'pages.login.phoneNumber.required': 'Por favor entre com seu telefone!',
  'pages.login.phoneNumber.invalid': 'Telefone é inválido!',
  'pages.login.captcha.placeholder': 'Código de Verificação',
  'pages.login.captcha.required':
    'Por favor entre com o código de verificação!',
  'pages.login.phoneLogin.getVerificationCode': 'Obter Código',
  'pages.getCaptchaSecondText': 'seg(s)',
  'pages.login.rememberMe': 'Lembre-me',
  'pages.login.forgotPassword': 'Perdeu a Senha ?',
  'pages.login.submit': 'Enviar',
  'pages.login.loginWith': 'Login com :',
  'pages.login.registerAccount': 'Registra Conta',
  'pages.welcome.link': 'Bem-vindo',
  'pages.welcome.alertMessage':
    'Componentes pesados mais rápidos e mais fortes foram lançados.',
  'pages.404.subTitle': 'Desculpe, a página que você visitou não existe. ',
  'pages.404.buttonText': 'Voltar à página inicial',
  'pages.admin.subPage.title': 'Esta página só pode ser vista pelo Admin',
  'pages.admin.subPage.alertMessage':
    'O Umi ui foi lançado, bem-vindo ao usar o npm run ui para iniciar a experiência.',
  'pages.searchTable.createForm.newRule': 'Neva Regra',
  'pages.searchTable.updateForm.ruleConfig': 'Configuração de Regra',
  'pages.searchTable.updateForm.basicConfig': 'Informação básica',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Nome da Regra',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Por favor entre com o nome da regra!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Descrição da Regra',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Por favor insira ao menos cinco caracteres',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Insira uma descrição de regra de pelo menos cinco caracteres!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configurar Propriedades',
  'pages.searchTable.updateForm.object': 'Objeto de Monitoramento',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Modelo de Regra',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Tipo de Regra',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Definir Período de Agendamento',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Hora de Início',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Por favor selecione um horáriod e início!',
  'pages.searchTable.titleDesc': 'Descrição',
  'pages.searchTable.ruleName': 'O nome da regra é obrigatório',
  'pages.searchTable.titleCallNo': 'Número de chamadas de serviço',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'padrão',
  'pages.searchTable.nameStatus.running': 'executando',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'anormal',
  'pages.searchTable.titleUpdatedAt': 'Última programação em',
  'pages.searchTable.exception': 'Por favor, indique o motivo da exceção!',
  'pages.searchTable.titleOption': 'Opção',
  'pages.searchTable.config': 'Configuração',
  'pages.searchTable.subscribeAlert': 'Inscreva-se para receber alertas',
  'pages.searchTable.title': 'Formulário de Consulta',
  'pages.searchTable.new': 'Novo',
  'pages.searchTable.chosen': 'selecionado',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Número total de chamadas de serviço',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'deleção em lote',
  'pages.searchTable.batchApproval': 'aprovação em lote',
  
  // Order Statistics Page
  'pages.orders.statistics.title': 'Estatísticas de Pedidos',
  'pages.orders.statistics.dateRange': 'Período',
  'pages.orders.statistics.last7Days': 'Últimos 7 Dias',
  'pages.orders.statistics.last30Days': 'Últimos 30 Dias',
  'pages.orders.statistics.last90Days': 'Últimos 90 Dias',
  'pages.orders.statistics.totalOrders': 'Total de Pedidos',
  'pages.orders.statistics.totalSales': 'Total de Vendas',
  'pages.orders.statistics.refundCount': 'Quantidade de Produtos Reembolsados',
  'pages.orders.statistics.refundAmount': 'Valor do Reembolso',
  'pages.orders.statistics.trendChart': 'Gráfico de Tendência de Negócios',
  'pages.orders.statistics.dailyStats': 'Estatísticas Diárias',
  'pages.orders.statistics.chart.orders': 'Pedidos',
  'pages.orders.statistics.chart.revenue': 'Receita',
  'pages.orders.statistics.chart.refunds': 'Reembolsos',
  'pages.orders.statistics.table.date': 'Data',
  'pages.orders.statistics.table.orderCount': 'Quantidade de Pedidos',
  'pages.orders.statistics.table.revenue': 'Receita',
  'pages.orders.statistics.table.refundCount': 'Quantidade de Reembolsos',
  'pages.orders.statistics.table.refundAmount': 'Valor do Reembolso',
  'pages.orders.statistics.table.total': 'Total de {total} itens',

  // Configurações de Rebate ao Vivo
  'pages.live.rebate.title': 'Configurações de Rebate ao Vivo',
  'pages.live.rebate.liveTeamName': 'Nome da Equipe ao Vivo',
  'pages.live.rebate.memberId': 'ID do Membro',
  'pages.live.rebate.sellerId': 'ID do Vendedor',
  'pages.live.rebate.sellerPercent': 'Vendedor %',
  'pages.live.rebate.companyPercent': 'Empresa %',
  'pages.live.rebate.teamPercent': 'Equipe %',
  'pages.live.rebate.teamRebatePercent': 'Rebate da Equipe %',
  'pages.live.rebate.settingTimeAdmin': 'Hora da Configuração / Admin',
  'pages.live.rebate.actions': 'Ações',
  'pages.live.rebate.setting': 'Configuração',
  'pages.live.rebate.detail': 'Detalhe',
  'pages.live.rebate.delete': 'Excluir',
  'pages.live.rebate.addRebate': 'Adicionar Rebate',
  'pages.live.rebate.batchUpdate': 'Atualização em Lote',
  'pages.live.rebate.selectFirst': 'Por favor, selecione os itens primeiro',
  'pages.live.rebate.addSuccess': 'Rebate adicionado com sucesso',
  'pages.live.rebate.addFailed': 'Falha ao adicionar rebate',
  'pages.live.rebate.updateSuccess': 'Rebate atualizado com sucesso',
  'pages.live.rebate.updateFailed': 'Falha ao atualizar rebate',
  'pages.live.rebate.deleteSuccess': 'Rebate excluído com sucesso',
  'pages.live.rebate.deleteFailed': 'Falha ao excluir rebate',
  'pages.live.rebate.deleteConfirm': 'Excluir Rebate',
  'pages.live.rebate.deleteContent': 'Tem certeza de que deseja excluir esta configuração de rebate?',
  'pages.live.rebate.addModalTitle': 'Adicionar Configuração de Rebate',
  'pages.live.rebate.editModalTitle': 'Editar Configuração de Rebate',
  'pages.live.rebate.liveTeamNameRequired': 'Por favor, insira o nome da equipe ao vivo',
  'pages.live.rebate.memberIdRequired': 'Por favor, insira o ID do membro',
  'pages.live.rebate.sellerIdRequired': 'Por favor, insira o ID do vendedor',
  'pages.live.rebate.sellerPercentRequired': 'Por favor, insira a porcentagem do vendedor',
  'pages.live.rebate.companyPercentRequired': 'Por favor, insira a porcentagem da empresa',
  'pages.live.rebate.teamPercentRequired': 'Por favor, insira a porcentagem da equipe',
  'pages.live.rebate.teamRebatePercentRequired': 'Por favor, insira a porcentagem de rebate da equipe',
  'pages.live.rebate.loadFailed': 'Falha ao carregar configurações de rebate',
  'pages.live.rebate.selectAtLeastTwo': 'Por favor, selecione pelo menos 2 itens',
  'pages.live.rebate.batchSetting': 'Configuração em Lote',
  'pages.live.rebate.batchUpdateTitle': 'Atualizar Porcentagens em Lote',
  'pages.live.rebate.selectedItems': 'itens selecionados',
  'pages.live.rebate.applySetting': 'Aplicar Configuração',
  'pages.live.rebate.cancel': 'Cancelar',
  'pages.live.rebate.batchUpdateSuccess': 'Atualização em lote concluída com sucesso',
  'pages.live.rebate.batchUpdateFailed': 'Falha na atualização em lote',
  'pages.live.rebate.searchLabel': 'Pesquisar',
  'pages.live.rebate.searchPlaceholder': 'Pesquisar por nome da equipe ao vivo, ID do vendedor ou ID do membro',
  'pages.live.rebate.search': 'Pesquisar',
  'pages.live.rebate.reset': 'Redefinir',
  'pages.live.rebate.teamLead': 'Líder da Equipe',
  'pages.live.rebate.teamLeadId': 'ID do Líder da Equipe',
  'pages.live.rebate.teamLeadIdRequired': 'Por favor, insira o ID do líder da equipe',
  'pages.live.rebate.teamInternalSelfPercent': 'Interno da Equipe Próprio %',
  'pages.live.rebate.teamInternalSelfPercentRequired': 'Por favor, insira a porcentagem interna própria da equipe',
  'pages.live.rebate.teamInternalUplinePercent': 'Interno da Equipe Superior %',
  'pages.live.rebate.teamRebate': 'Rebate da Equipe',
  'pages.live.rebate.memberSettings': 'Config. de Membros',
  'pages.live.rebate.memberSettingsTitle': 'Configurações de rebate por vendedor',
  'pages.live.rebate.memberSettingsHint': 'Defina os percentuais de rebate de cada vendedor. Valores salvos substituem as configurações da equipe para esse vendedor; vendedores "Não definido" continuam usando as configurações da equipe.',
  'pages.live.rebate.memberSource': 'Origem',
  'pages.live.rebate.memberSourceTeamCopy': 'Copiado da equipe',
  'pages.live.rebate.memberSourceAdmin': 'Definido individualmente',
  'pages.live.rebate.memberSourceNone': 'Não definido (config. da equipe)',
  'pages.live.rebate.memberSourceTeamConfig': 'Config. da equipe',
  'pages.live.rebate.memberSelfPercent': '% próprio',
  'pages.live.rebate.memberSave': 'Salvar',
  'pages.live.rebate.memberSaveSuccess': 'Configurações de rebate do vendedor salvas',
  'pages.live.rebate.memberSaveFailed': 'Falha ao salvar as configurações de rebate do vendedor',
  'pages.live.rebate.memberLoadFailed': 'Falha ao carregar os membros da equipe',
  'pages.live.rebate.marginSumError': 'Vendedor + Empresa + Equipe % deve somar 100',
  'pages.live.rebate.teamLeadTag': 'Líder da equipe',
  'pages.live.rebate.teamInternalUplinePercentRequired': 'Por favor, insira a porcentagem interna superior da equipe',
  'pages.live.rebate.configuredAt': 'Configurado Em',
  'pages.live.rebate.configuredAtRequired': 'Por favor, selecione a data de configuração',
  'pages.live.sellers.userId': 'ID do Usuário',
  'pages.live.sellers.sellerId': 'ID do Vendedor',
  'pages.live.sellers.name': 'Nome',
  'pages.live.sellers.recommender': 'Indicador',
  'pages.live.sellers.team': 'Membros da Equipe',
  'pages.live.sellers.follower': 'Seguidores',
  'pages.live.sellers.salesAmount': 'Valor de Vendas',
  'pages.live.sellers.salesCount': 'Qtd. de Vendas',
  'pages.live.sellers.rebate': 'Rebate Acumulado',
  'pages.live.sellers.refundAmount': 'Valor de Reembolso',
  'pages.live.sellers.rebateDeduction': 'Dedução de Rebate',
  'pages.live.sellers.liveStatus': 'Status ao Vivo',
  'pages.live.sellers.liveStatus.live': 'Ao Vivo',
  'pages.live.sellers.liveStatus.idle': 'Ocioso',
  'pages.live.sellers.homepage': 'Página Inicial',
  'pages.live.sellers.homepageLink': 'Link',
  'pages.live.sellers.actions': 'Ações',
  'pages.live.rebate.levelDetailTitle': 'Lista de Times Live',
  'pages.live.rebate.levelDetail.column.teamName': 'Nome da Equipe',
  'pages.live.rebate.levelDetail.column.depth': 'Nível',
  'pages.live.rebate.levelDetail.column.userUniqueId': 'ID do Vendedor',
  'pages.live.rebate.levelDetail.column.userId': 'ID do Usuário',
  'pages.live.rebate.levelDetail.column.userName': 'Nome do Usuário',
  'pages.live.rebate.levelDetail.column.subordinateSellerCount': 'Quantidade de Subordinados',
  'pages.live.rebate.levelDetail.column.salesAmountKrw': 'Valor de Vendas (KRW)',
  'pages.live.rebate.levelDetail.column.marginAmountKrw': 'Valor da Margem (KRW)',
  'pages.live.rebate.levelDetail.column.salesQuantity': 'Quantidade de Vendas',
  'pages.live.rebate.levelDetail.column.refundAmountKrw': 'Valor do Reembolso (KRW)',
  'pages.live.rebate.levelDetail.column.refundQuantity': 'Quantidade de Reembolso',
  'pages.live.rebate.levelDetail.column.teamRebateAccruedKrw': 'Rebate da Equipe Acumulado (KRW)',
  'pages.live.rebate.levelDetail.column.teamRebateDeductedKrw': 'Rebate da Equipe Deduzido (KRW)',
  'pages.live.rebate.levelDetail.column.teamRebateAfterRefundKrw': 'Rebate da Equipe Após Reembolso (KRW)',
  'pages.live.rebate.levelDetail.column.platformAccruedKrw': 'Empresa Acumulada (KRW)',
  'pages.live.rebate.levelDetail.column.platformDeductedKrw': 'Empresa Deduzida (KRW)',
  'pages.live.rebate.levelDetail.column.platformAfterRefundKrw': 'Empresa Após Reembolso (KRW)',
  'pages.live.rebate.levelDetail.column.action': 'Ação',
  'pages.live.rebate.levelDetail.searchLabel': 'Pesquisar:',
  'pages.live.rebate.levelDetail.searchPlaceholder': 'Pesquisar por ID do vendedor, ID do usuário ou nome do usuário...',
  'pages.live.rebate.levelDetail.searchButton': 'Pesquisar',
  'pages.live.rebate.levelDetail.resetButton': 'Redefinir',
  'pages.live.rebate.levelDetail.reloadButton': 'Recarregar',
  'pages.live.rebate.levelDetail.detailButton': 'Detalhe',
  'pages.live.rebate.levelDetail.loadError': 'Falha ao carregar dados de detalhe do rebate ao vivo',
  'pages.live.rebate.levelDetail.level1': 'Nível 1',
  'pages.live.rebate.levelDetail.level2': 'Nível 2',
  'pages.live.rebate.levelDetail.level3': 'Nível 3',
  'pages.live.rebate.levelDetail.level4': 'Nível 4',
};
